// extracted by mini-css-extract-plugin
module.exports = {"text":"DeliveryFormFooter_text__d0Mfj","notText":"DeliveryFormFooter_notText__RbkyJ","subText":"DeliveryFormFooter_subText__YWOVh"};